import React, { ButtonHTMLAttributes } from "react";

import { ConsolePageButtonContainer } from "./styles";

type IConsolePageButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export const ConsolePageButton = ({ ...props }: IConsolePageButtonProps) => {
  return <ConsolePageButtonContainer {...props} />;
};
